<h2 class="text-center" [innerHTML]="textkeyPrefix + '.headline' | translate"></h2>

<div class="teaser">
  <i class="icon-cost-increase-chart"></i>
  <p [innerHTML]="textkeyPrefix + '.teaser' | translate"></p>
</div>

<div class="heating-costs-wrapper">

  <div class="bar-group current">
    @if (mode === 'hec') {
      <div  class="group-title">
        <span [innerHTML]="textkeyPrefix + '.aktuell' | translate"></span><b class="show-for-small-only">:</b>
      </div>
    }

    @if (compareData.costs) {
      <div class="chart-container {{mode === 'hec' && compareData.costs.percent > 0.9 ? 'extra-padding' : ''}}">

        @if (compareData.average) {
          <div class="bar-wrapper">
            <div class="bar bar-gray" (click)="hints.avg = !hints.avg" [style.height.%]="compareData.average.percent * 100">
              <span class="value-label">∅ {{compareData.average.value | number: '1.0-0'}} {{ 'unit.' + costsUnit | translate }}</span>
              <span class="year-text">{{ this.placeholder['lastyear'] }}</span>
            </div>
          </div>
        }

        <div class="bar-wrapper">
          <div class="bar bar-primary" [style.height.%]="compareData.costs.percent * 100" [style.justify-content]="compareData.costs.waterPercent > 0 ? 'spacebetween' : 'flex-end'">
            <div class="value-label input-value">
              {{ compareData.costs.value | number: '1.0-0' }} {{ 'unit.' + costsUnit | translate }}
            </div>
            @if (compareData.costs.waterPercent > 0) {
              <div class="segment-container">
                <div class="segment water" [style.min-height.%]="(compareData.costs.waterPercent < 0.2 ? 0.2 : compareData.costs.waterPercent) * 100">
                  <i class="icon-shower" [title]="textkeyPrefix + '.kosten.warmwasser' | translate"></i>
                </div>
                <div class="segment heating">
                  <i class="icon-house-temperature" [title]="textkeyPrefix + '.kosten.raumwaerme' | translate"></i>
                </div>
              </div>
            }
            <span class="year-text">{{ this.placeholder['lastyear'] }}</span>
          </div>
        </div>
      </div>
    }

    @if (compareData.average) {
      <div class="infotext-wrapper average">
        <button type="button" [attr.aria-expanded]="hints.avg" aria-controls="avg-hint" (click)="onButtonClick('avg')" class="infocallout-button"><i class="icon-info"></i>
        <span [innerHTML]="textkeyPrefix + '.durchschnitt.hint.label' | translate"></span>
      </button>
    </div>
    @if (hints.avg) {
      <div id="avg-hint" class="callout light-gray infocallout">
        <button type="button" class="close" [attr.aria-label]="'arialabel.close' | translate" (click)="hints.avg = false"><i class="icon-x"></i></button>
        <h4 [innerHTML]="textkeyPrefix + '.durchschnitt.text.headline' | translate"></h4>
        <div [innerHTML]="textkeyPrefix + '.durchschnitt.text.' + textCases.avg | translate"></div>
      </div>
    }
  }

    @if (compareData.costs) {
    <div class="infotext-wrapper costs">
      <button type="button" [attr.aria-expanded]="hints.costs" aria-controls="costs-hint" (click)="onButtonClick('costs')" class="infocallout-button"><i class="icon-info"></i>
      <span [innerHTML]="textkeyPrefix + '.kosten.hint.label' | translate"></span>
    </button>
  </div>
  @if (hints.costs) {
    <div id="costs-hint" class="callout light-gray infocallout">
      <button class="close"  [attr.aria-label]="'arialabel.close' | translate" (click)="hints.costs = false"><i class="icon-x"></i></button>
      <h4 [innerHTML]="textkeyPrefix + '.kosten.text.headline' | translate"></h4>
      @if (mode === 'hka') {
        <p [innerHTML]="textkeyPrefix + '.kosten.text' | translate"></p>
      }
      @if (mode === 'hec' && dataCases.stages) {
        <div class="grid-x grid-margin-x">
          <div class="cell small-12">
            <p [innerHTML]="(textkeyPrefix + '.kosten.text' + textCases.costs) | translate: placeholder"></p>
            <p [innerHTML]="textkeyPrefix +'.kosten.energiepreis.' + dataCases.stages.energyprice | translate: placeholder"></p>
            @if (forecastData.real[0].extraCosts > 0) {
              <p [innerHTML]="textkeyPrefix +'.kosten.nebenkosten.' + dataCases.stages.extracosts | translate: placeholder"></p>
            }
          </div>
            @if (dataCases.hasWarmwater) {
              <div class="cell small-12 water-wrapper">
                <div class="hide-for-small-only">
                  <i class="icon-shower"></i>
                </div>
                <div [innerHTML]="textkeyPrefix +'.kosten.warmwasser.' + dataCases.stages.warmwater | translate: placeholder"></div>
              </div>
            }
        </div>
      }
    </div>
  }
}
</div>


  @if (mode === 'hec') {
    <div class="grid-line hide-for-small-only"></div>
  }

  <div class="bar-group forecast">
    @if (mode === 'hec') {
      <div class="forecast-wrapper">
        <div class="forecast-arrow">
          <span [innerHTML]="textkeyPrefix + '.prognose' | translate"></span><b class="show-for-small-only">:</b>
        </div>
          <div class="costs-toggle-wrapper">
            <mat-radio-group [attr.aria-label]="textkeyPrefix + '.prognose.toggle.label' | translate" [ngModel]="forecastData.activeType" (change)="changeForecastType($event.value)" color="primary">
              <mat-radio-button value="real">
                <span [innerHTML]="textkeyPrefix + '.real.label' | translate"></span>
              </mat-radio-button>
              <mat-radio-button value="market">
                <span [innerHTML]="textkeyPrefix + '.market.label' | translate"></span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
      </div>
    }
    @if (forecastData) {
      <div class="chart-container">
        @for (row of forecastData[forecastData.activeType]; track row.year) {
          <div class="bar-wrapper">
            <div class="bar bar-red" [style.height.%]="row.percentage * 100">
              <div class="value-label">
                {{mode === 'hec' ? 'ca.' : '' }} {{ row.costs | number: '1.0-0' }} {{ 'unit.' + costsUnit | translate }}</div>

              @if (row.co2 > 0) {
                <div class="co2-flag" [style.height.%]="row.co2 * 100">
                  <span class="co2-label" [innerHTML]="'unit.co2' | translate"></span>
                </div>
              }

              <span class="year-text">{{ row.year }}</span>
            </div>
          </div>
        }
      </div>

    <div class="infotext-wrapper">
      <button type="button" [attr.aria-expanded]="hints.forecast" aria-controls="forecast-hint" (click)="onButtonClick('forecast')" class="infocallout-button"><i class="icon-info"></i>
        <span [innerHTML]="textkeyPrefix + '.prognose.hint.label' | translate"></span>
    </button>
  </div>
  @if (hints.forecast) {
    <div id="forecast-hint" class="callout light-gray infocallout">
      <button type="button" class="close" [attr.aria-label]="'arialabel.close' | translate" (click)="hints.forecast = false"><i class="icon-x"></i></button>
      <h4 [innerHTML]="textkeyPrefix + '.prognose.text.headline' | translate"></h4>
      @for (textCase of textCases.forecast; track $index) {
        <div [innerHTML]="textkeyPrefix + '.prognose.text' + textCase | translate: placeholder"></div>
      }
    </div>
  }
}

  </div>
</div>
